import { FunctionComponent } from 'react';
import { HeroBannerLayout, Page } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';

import logo from '../../../assets/images/onboarding_telia_logo.png';
import BottomContent from './BottomContent';

const GetStarted: FunctionComponent = () => {
  const { t } = useTranslation('onboarding');
  return (
    <Page>
      <HeroBannerLayout
        heading={t('getStarted.welcomeTitle')}
        description={t('getStarted.welcomeContent')}
        image={logo}
        imageAlt={'Telia logo'}
        bottomContent={<BottomContent />}
        color={'black'}
        headlineTagName={'h1'}
      />
    </Page>
  );
};

export default GetStarted;
